.container {
  display: grid;
  gap: 5px;
  padding: 5px;
}
